<template>
  <div>
    <Form ref="searchForm" :label-width="80" :model="formCustom" inline>
      <Form-item label="模块标题：" prop="title">
        <Input v-model="formCustom.title" clearable placeholder="请输入" style="width: 200px"></Input>
      </Form-item>
      <Form-item label="开始日期：" prop="startTime">
        <DatePicker v-model="formCustom.startTime" placeholder="请选择" placement="bottom-end" style="width: 200px"
                    type="date" @on-change='changeStartTime'></DatePicker>
      </Form-item>
      <Form-item label="结束日期：" prop="endTime">
        <DatePicker v-model="formCustom.endTime" placeholder="请选择" placement="bottom-end" style="width: 200px"
                    type="date" @on-change='changeEndTime'></DatePicker>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div>
      <Table :columns="operLogColumns" :data="operLogTableData" :loading="loading" aria-describedby=""
             aria-hidden="true" border>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
  </div>
</template>

<script>
import {operLogClean, operLogDelete, operLogPage} from '@/api/authority'
import permissionList from '@/libs/handlePermission.ts'

export default {
  name: 'operLog',
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      formCustom: {
        title: '',
        startTime: '',
        endTime: ''
      },
      operLogColumns: [
        {title: '日志编号', key: 'operId', width: '100', align: 'center'},
        {title: '模块标题', key: 'title', align: 'center'},
        {title: '操作类型', key: 'businessName', width: '240', align: 'center'},
        {title: '请求方式', key: 'requestMethod', width: '100', align: 'center'},
        {title: '用户账号', key: 'operName', width: '160', align: 'center'},
        {title: '主机', key: 'operIp', width: '140', align: 'center'},
        {title: '操作日期', key: 'createTime', width: '180', align: 'center'},
        // { title: '操作', slot: 'action', width: '120', align: 'center', fixed: 'right' }
      ],
      operLogTableData: [] // 表格数据
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
  },
  methods: {
    // 初始化
    async init() {
      this.loading = true
      operLogPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.operLogTableData = res.data.data.records
      this.loading = false
    },
    // 查询
    handleSearch() {
      this.loading = true
      operLogPage({
        current: 1,
        size: this.pageSize,
        title: this.formCustom.title,
        startTime: this.formCustom.startTime,
        endTime: this.formCustom.endTime
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    changeStartTime(val) {
      this.formCustom.startTime = val
    },
    changeEndTime(val) {
      this.formCustom.endTime = val
    },
    // 改变页码
    setCurrent(val) {
      this.loading = true
      this.page = val
      operLogPage({
        current: val,
        size: this.pageSize,
        title: this.formCustom.title,
        startTime: this.formCustom.startTime,
        endTime: this.formCustom.endTime
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      this.pageSize = val
      operLogPage({
        current: 1,
        size: this.pageSize,
        title: this.formCustom.title,
        startTime: this.formCustom.startTime,
        endTime: this.formCustom.endTime
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 删除
    remove(id) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          operLogDelete(id).then((res) => {
            if (res.data.success === false) {
              this.$Message.warning(res.data.msg)
            } else {
              this.$Message.success(res.data.msg)
            }
            this.init()
          }).catch(() => {
          })
        },
        onCancel: () => {
          this.$Message.info('已取消删除')
        }
      })
    },
    // 清空
    cleanAll() {
      this.$Modal.confirm({
        title: '确认清空？',
        onOk: () => {
          operLogClean().then((res) => {
            if (res.data.success === false) {
              this.$Message.warning(res.data.msg)
            } else {
              this.$Message.success(res.data.msg)
            }
            this.init()
          }).catch(() => {
          })
        },
        onCancel: () => {
          this.$Message.info('已取消清空')
        }
      })
    }
  }
}
</script>
